import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash";

declare var $: any;

@Pipe({
  name: 'gridProperty'
})
export class TransformGridPropertyPipe implements PipeTransform {
  transform(attr: any, item: any) {
    return typeof(attr) == 'function' ? attr(item) : attr;
  }
}

@Pipe({
  name: 'dataList2Filter'
})
export class DataList2FilterPipe implements PipeTransform {
  transform(array: any[], fields: any[], query: any): any {
    if(!!query) {
      query = query.toUpperCase();

      let nArr = _.filter(array, row => {
        let result = false;

        fields.forEach(field => {
          if (!!row[field.key]) {
            let value = String(row[field.key]).toUpperCase();

            result = result || value.indexOf(query) > -1;            
          }
        });

        return result;
      });

      // console.log(nArr);

      return nArr;
    }

    return array;
  }
}

@Component({
  selector: 'ing-data-grid2',
  templateUrl: './data-grid2.component.html',
  styleUrls: ['./data-grid2.component.scss']
})
export class DataGrid2Component implements OnInit {
  
  @Input() title: string;
  @Input() subtitle: string;
  @Input() newItemText: string;
  @Input() dataLst: Array<any>;
  @Input() fields: Array<any> = [];

  @Input() rowsOnPage: number = 20;
  @Input() sortBy: string;
  @Input() sortOrder: string = 'asc';

  @Input() renderBtnNuevo : boolean = true;

  @Output() edit                  = new EventEmitter();
  @Output() create                = new EventEmitter();
  @Output() delete                = new EventEmitter();
  @Output('grid-click') gridClick = new EventEmitter();

  @Input('grid-buttons') gridButtons: Array<{cssClass: string, icon?: string, text?: string, tooltip?: string}> = null;

  filterQuery: any;

  constructor() { }

  ngOnInit() {
    $('.loader-inner').loaders();
  }

  ngOnChanges(changes: any) {
    if(!!changes.dataLst && changes.dataLst.currentValue == null) {
      setTimeout(() => {
        $('.loader-inner').loaders();
      });
    }
  }

  onCreate() {
    this.create.next();
  }

  onEdit(item: any) {
    console.log(this.filterQuery);
    this.edit.next(item);
  }

  onDelete(item: any) {
    this.delete.next(item);
  }

  onButtonGridClick(i, item) {
    this.gridClick.next({
      button: i,
      item: item
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-list/data-grid2/data-grid2.component.ts